import React, { FC } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { Box, makeStyles, Theme } from 'transfix-ui/core'
import { ReactComponent as IntuitQuickbooksLogo } from 'apps/fleet-planner/components/illustrations/logos/IntuitQuickbooksLogo.svg'

const LOGO_MAX_WIDTH = 143

const useQuickBooksInfoCardStyles = makeStyles((theme: Theme) => ({
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: LOGO_MAX_WIDTH,

    // Ensure that the logo is only as big as the containing div
    '& > svg': {
      maxWidth: '100%',
    },
  },
}))

interface IQuickBooksInfoCardProps {
  quickbooksInvoiceId: string | undefined
  createdAt?: string
}

/**
 * Displays the current QuickBooks invoice data in the Load Details modal
 */
export const QuickBooksInfoCard: FC<IQuickBooksInfoCardProps> = ({
  createdAt,
  quickbooksInvoiceId,
}) => {
  const classes = useQuickBooksInfoCardStyles()
  return (
    <Card size='small'>
      <Box display='flex'>
        <Box className={classes.logoWrapper}>
          <IntuitQuickbooksLogo />
        </Box>
        <Box flex='1 1 auto' display='flex' alignItems='center'>
          <Box>QuickBooks Invoice #{quickbooksInvoiceId}</Box>
          {createdAt && (
            <Box>
              <div className='text-disabled'>Invoice created {createdAt}</div>
            </Box>
          )}
        </Box>
      </Box>
    </Card>
  )
}
